// Which parts of the app a site can be given or not given.
//
// One list, read by two places: the Site Settings screen that sets them, and
// the top bar that draws itself from them. They have to agree - a module the
// settings screen can switch off but the bar does not know about is a tick box
// that does nothing.
//
// The stored value records exceptions only. A key absent means on, so a module
// added to this list is on everywhere until somebody switches it off, and no
// site is left behind with a stale list.

export const SITE_MODULES = [
  { key: 'ordering_area',      label: 'Orders',
    note: 'The Orders area: Job Queue, Place an Order, Client Ordering and Regional Product Movement.' },
  { key: 'client_ordering',    label: 'Client Ordering',
    note: 'Orders placed on behalf of a client. Inside Orders.' },
  { key: 'inventory_movement', label: 'Regional Product Movement',
    note: 'Reading handwritten movement pages. Inside Ordering.' },
  { key: 'reports',            label: 'Reports',
    note: 'The Reports area and every report in it.' },
  { key: 'catalog',            label: 'Item Catalog',
    note: 'Products, costs and categories.' },
  { key: 'shrink_analysis',    label: 'Shrink Analysis',
    note: 'On the roadmap. The menu item is in place so navigation stays consistent.' },
  /* The owner's own setup tools, 6 October 2026. Hide it when setup is done. */
  { key: 'setup_area',         label: 'Setup',
    note: 'Item, Vendor and Place Mapping, for setting OnHand up the first time. Only a Global Admin sees it. Hide it once setup is finished; nothing it saved is lost.' },
];

// Counting and Settings are deliberately not in that list. Counting is the
// product - a site without it has nothing to log into - and switching Settings
// off would take away the screen that switches it back on.
// Appearance too, since theme phase 5: a site cannot take away a person's own theme.
export const ALWAYS_ON = ['operations', 'overview', 'warehouses', 'settings_area', 'users_access', 'uploads', 'appearance'];

// Absent means on. Only an explicit false switches something off, so a value
// written before a module existed cannot accidentally hide it.
export function moduleOn(modules, key) {
  if (!key || ALWAYS_ON.includes(key)) return true;
  return modules?.[key] !== false;
}
